import { Typography } from '@mui/material';

import Header from '../../../../components/Header';
import { headerLink } from '../../../../navigation/function';
import { accountNavigation } from '../../../../navigation/account';
import CertificationApply from '../../../../components/Users/certification/apply';

function ApplyCertification() {
    const accountLink = headerLink(accountNavigation.account);
    const certificationLink = headerLink(accountNavigation.certification);
    const pageLink = headerLink(accountNavigation.apply, true);

    return (
        <div className='space-y-8'>
            <Header>
                <div>
                    Members | {accountLink} | {certificationLink} | {pageLink}
                </div>
            </Header>
            <Typography variant='h3' color='black.main' className='mt-4'>
                CKA® Certification Application
            </Typography>

            <CertificationApply />
        </div>
    );
}

export default ApplyCertification;
